import { Controller } from '@hotwired/stimulus';
import { WebViewEvent, checkIfWebView } from '@infakt/webview-toolkit';

export default class extends Controller {
  connect() {
    if (!checkIfWebView()) return;

    new WebViewEvent({
      event: 'SetExitConfirmation',
      params: { enabled: false },
    }).dispatch();
  }
}
